import { PRODUCT_ON_ROW } from "@share/configs/const";
import React, { useMemo } from "react";
import ProductDetailStyle2 from "../../ProductDetail/ProductDetailStyle2";

const ProductStyleTextOverImage = (props) => {
  const {
    products,
    styleAttributes,
    affiliateProductGroupData,
    onUpdateProductGroupData,
    productGroupMaximum,
  } = props;

  const { style_display, item_on_row } = styleAttributes;

  const productListEnable = products?.filter((x) => x.enable === 1);

  const displayValueStyle = useMemo(() => {
    let gridStyleValue = null;
    switch (item_on_row) {
      case PRODUCT_ON_ROW.ONE:
        gridStyleValue = {
          display: "grid",
          gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
          gap: "12px",
        };
        break;
      case PRODUCT_ON_ROW.TWO:
        gridStyleValue = {
          display: "grid",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          gap: "12px",
        };
        break;
      case PRODUCT_ON_ROW.THREE:
        gridStyleValue = {
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
          gap: "12px",
        };
        break;
    }
    return gridStyleValue;
  }, [item_on_row]);

  return (
    <div>
      <div
        className="affiliate-product-wrapper"
        style={displayValueStyle}
      >
        {productListEnable?.map((ele, index) => (
          <ProductDetailStyle2
            product={ele}
            key={index}
            item_on_row={item_on_row}
            affiliateProductGroupData={affiliateProductGroupData}
            onUpdateProductGroupData={onUpdateProductGroupData}
            productGroupMaximum={productGroupMaximum}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductStyleTextOverImage;
